import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { Feedback, ReferencedRecognition } from '../lib';
import { FeedbackApiData } from '../types/feedback';
import { RecognitionApiData } from '../types/recognition';

export const useFeedback = (id?: string) => {
	const http = useHttpClient('v2');

	return useQuery(
		['feedback', id],
		async () => {
			const feedback = await http.get<FeedbackApiData>(`/constructive_feedback/feedback/${id}`);

			const noReferenceResponse = {
				feedback,
				reference: { data: { result: null } },
			};

			if (!feedback.data.reference_id) {
				return noReferenceResponse;
			}

			try {
				const reference = await http.get<{ result: RecognitionApiData }>(`/bonuses/${feedback.data.reference_id}`);

				return { feedback, reference };
			} catch (_err) {
				// Likely a 404 error due to privacy, so we return null for the reference
				return noReferenceResponse;
			}
		},
		{
			enabled: !!id,
			select: (data) => {
				const feedback = Feedback.fromApiData(data.feedback.data);

				if (data.reference?.data.result) {
					feedback.reference = ReferencedRecognition.fromApiData(data.reference.data.result);
				}

				return feedback;
			},
		}
	);
};
